import { render } from "./business_details.vue?vue&type=template&id=3ffe7ff0&scoped=true"
import script from "./business_details.vue?vue&type=script&lang=js"
export * from "./business_details.vue?vue&type=script&lang=js"

import "./business_details.vue?vue&type=style&index=0&id=3ffe7ff0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffe7ff0"]])

export default __exports__